import calls from '@/backend/api-calls'

const state = () => ({
  skid: null,
  firstLoad: true,
  loading: false
})

// getters
const getters = {
}

// actions
const actions = {
  getSkid: ({commit}, skidId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.skid.get(skidId).then(
        resp => {
          commit("setSkid", resp.data);
          commit("setFirstLoad", false);
          commit("setLoading", false);
          resolve(resp);
        }
      ).catch(err => {
        reject(err);
        commit("setLoading", false);
      });
    })
  },
  updateSkid: ({commit, state}, data) => {
    return new Promise((resolve, reject) => {
      calls.skid.put(state.skid.id, data).then(
        resp => {
          commit("setSkid", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Skid successfully updated.'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItems: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.installationItems.postBatch(data).then(
        resp => {
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItem: ({commit}, itemId) => {
    return new Promise((resolve, reject) => {
      calls.installationItem.delete(itemId).then(
        resp => {
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setSkid(state, data) {
    state.skid = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}